module.exports = __webpack_public_path__ + "static/media/Kinn.a48e0ce5.PNG";